<template>
  <div class="private-chat">
    <div class="private-header">
      <div class="a" @click="back">
        <img src="./img/back-arrow.png" alt="" />
        <div>返回</div>
      </div>
      <div class="c text-overflow">{{ userChatName }}</div>
      <div class="d" @click="clearMsgPopup(clearMsgDialog)">清空</div>
    </div>
    <div class="private-content" ref="privateChat" @scroll="onscroll">
      <img v-show="isLoadingMore" src="@/assets/img/loading-1.gif" alt="" style="display: block; margin: 0 auto" />
      <div class="message-list" v-for="(item, index) in userMessageList" :key="index">
        <div class="chat-time" v-show="item.chatType === 3">{{ item.content }}</div>
        <div class="chat-anchor" v-show="item.chatType === 2 && (item.content || item.image_url)">
          <div class="avatar">
            <img :src="item.avatar ? item.avatar : require('@/assets/img/default/default_logo1.png')" alt="" />
          </div>
          <div class="msg">
            <img class="angle" src="./img/angle-left.png" alt="" />
            <div class="nickname">
              <div>{{ item.nickname }}</div>
              <div class="role" v-show="item.role === 1">房管</div>
            </div>
            <div class="text">{{ item.content }}</div>
            <el-image v-show="item.image_url" :src="item.image_url" @load="loadImage" :preview-src-list="[item.image_url]"> </el-image>
          </div>
        </div>
        <div class="chat-user" v-show="item.chatType === 1 && (item.content || item.image_url)">
          <div class="msg">
            <div class="red-dot" v-show="errorMessageIds.indexOf(item.send_time) > -1" @click="showErrorMsg">!</div>
            <img class="angle" src="./img/angle-right.png" alt="" />
            <div class="text">{{ item.content }}</div>
            <el-image v-show="item.image_url" :src="item.image_url" @load="loadImage" :preview-src-list="[item.image_url]"> </el-image>
          </div>
          <img class="avatar" :src="userInfo.avatar ? userInfo.avatar : require('@/assets/img/default/default_logo1.png')" alt="" />
        </div>
      </div>
    </div>
    <div class="to_bottom_btn" @click="toBottom" v-if="showMoreMsg">底部有新的消息</div>
    <div class="message_bottom">
      <div class="icon_btn">
        <emoji-picker @emoji="insert">
          <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
            <img class="icon-img" src="./img/emoji.png" title="表情" />
          </div>
          <div class="emoji" slot="emoji-picker" slot-scope="{ emojis, insert }">
            <div class="emoji-cats">
              <div class="emoji-cat" :class="emojiCategory == index ? 'emoji-active' : ''" @click="changeEmojiCategory(index)" v-for="(item, index) in emojiCates" :key="index">
                {{ item }}
              </div>
            </div>
            <div v-for="(emojiGroup, category, index) in emojis" :key="category">
              <div class="emoji-item" v-if="emojiCategory == index">
                <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
              </div>
            </div>
          </div>
        </emoji-picker>
        <el-upload
          :multiple="false"
          :before-upload="beforeUpload"
          :http-request="handleUpload"
          class="upload-demo"
          :show-file-list="false"
          :auto-upload="true"
          :action="'/asd'"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          v-loading="isUpLoading"
        >
          <img class="icon-img" style="width: 0.25rem; height: 0.25rem" src="./img/picture.png" alt />
        </el-upload>
      </div>
      <div class="sent_content">
        <div class="input_content">
          <input type="text" class="login_input" required="required" @input="formatMessage" v-model="messageContent" @keyup.enter="sendMsg()" />
        </div>
        <div class="input_send" @click.stop="sendMsg">发送</div>
      </div>
    </div>
    <ConfirmDialog :content="content" @confirmDialog="confirmDialog" ref="confirmDialog" />
    <SendPicture :sendPicture="sendPicture" :isLoadingPic="isLoadingPic" @clearPicture="clearPicture" @confirmDialog="confirmDialog" ref="sendPicture" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import { EmojiPicker } from "vue-emoji-picker";
import TIM from "tim-js-sdk";
import { tim } from "@/util/tim";
import { format } from "@/util/time";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
import SendPicture from "@/components/dialog/SendPicture";
import uploadByCosSdk from "@/mixins/uploadByCosSdk";

export default {
  mixins: [uploadByCosSdk],
  components: { EmojiPicker, ConfirmDialog, SendPicture },
  computed: {
    ...mapState(["userInfo", "appConfig", "userMessageList", "groupInfo", "loginRepData", "fanGroup", "noMoreMsg", "isLoadingMore", "userChatId", "userChatName", "enterUserChatFlag"]),
    roomId() {
      return this.liveDetail.anchorid || 0;
    },
  },
  props: {
    liveDetail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    userMessageList(newVal) {
      if (!this.isBottom) {
        this.showMoreMsg = true;
      }
      if (this.isBottom) {
        console.log("toBottom");
        this.toBottom();
      }
    },
  },

  data() {
    return {
      emojiCates: ["常用", "笑脸", "动物", "物品"],
      messageContent: "",
      emojiCategory: 0,
      errorMessageIds: [],
      errorMsg: "",
      deleteMsgId: 0,
      content: "",
      clearMsgDialog: ["确定要清空消息吗？"],
      showMoreMsg: false,
      isBottom: true,
      isUpLoading: false,
      sendPicture: "",
      page: 1,
      isLoadingPic: false,
    };
  },
  created() {},
  destroyed() {
    this.changeUserChatId(0);
    this.changeUserMessageList([]);
    this.readUserChat(this.userChatId);
  },
  mounted() {
    this.getUserHistory({ uid: this.userChatId });
    this.changeNoMoreMsg(false);
  },
  methods: {
    ...mapMutations(["changeUserInfo", "toggleLogin", "pushToast", "changeUserMessageList", "changeNoMoreMsg", "changeUserChatId"]),
    ...mapActions(["getGroupInfo", "getUserHistory", "readUserChat"]),

    loadImage() {
      if (this.isBottom) {
        this.toBottom();
      }
    },
    clearPicture() {
      this.sendPicture = "";
    },
    handleUpload(res) {
      const file = res.file;
      this.$refs.sendPicture.open();
      this.isLoadingPic = true;
      this.upload(file)
        .then((res) => {
          if (res.status === 0) {
            console.log("handleUpload", res);
            this.sendPicture = res.data;
            this.isLoadingPic = false;
          }
        })
        .finally((err) => {
          console.log(err);
        });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isJpeg = file.type === "image/jpeg";
      if (!isJPG && !isGIF && !isPNG && !isJpeg) {
        this.$message.error("发送图片必须是JPG/GIF/PNG 格式!");
        return false;
      }
    },
    clearMsgPopup(val) {
      this.content = val;
      this.$refs.confirmDialog.open();
    },

    confirmDialog(val) {
      if (val === this.sendPicture) {
        console.log(val);
        this.sendMsg();
      } else if (val === this.clearMsgDialog) {
        console.log(val);
        this.clearMsg();
      }
    },
    back() {
      if (this.enterUserChatFlag === 1) {
        this.$emit("toGroupMembers");
      } else {
        this.$emit("toGroupChatUserChatBack");
      }
    },
    toGroupInfo() {
      this.$emit("toGroupInfo", this.fanGroup);
    },
    changeEmojiCategory(category) {
      this.emojiCategory = category;
    },
    insert(emoji) {
      this.messageContent += emoji;
    },
    clearMsg() {
      post({
        url: "/api/mgrChat/delHistory",
        data: { user_id: this.userChatId },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.$message.success("清空聊天记录成功");
            this.changeUserMessageList([]);
            this.getUserHistory({ uid: this.userChatId });
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    formatMessage() {
      if (this.messageContent.length > 200 && this.groupInfo.user_info.role !== 1) {
        this.messageContent = this.messageContent.slice(0, 200);
        this.$message.error("已达到数字上限");
      }
    },
    sendMsg() {
      // console.log("url", url);
      if (!this.messageContent.trim() && this.sendPicture === "") {
        this.messageContent = "";
        this.pushToast("输入不能为空");
        return;
      }

      // 发送消息
      const msg = {
        type: "mgr_message",
        groupId: this.userChatId,
        content: window.encrypt(this.messageContent.trim()), //接口提供wasm加密
        image_url: this.sendPicture,
      };

      console.log("userMessageList:::::::::", this.userMessageList);
      let nowTime = Date.parse(new Date());
      let lastMsgTime = this.userMessageList[this.userMessageList.length - 1]?.send_time || 0;
      console.log(nowTime, lastMsgTime, "time");
      //相隔60秒添加时间线
      if (nowTime - lastMsgTime > 60000) {
        this.userMessageList.push({
          chatType: 3,
          send_time: nowTime,
          content: format(nowTime, "MM-dd hh:mm"),
        });
      }
      this.userMessageList.push({
        chatType: 1,
        send_time: nowTime,
        content: this.messageContent.trim(),
        image_url: this.sendPicture,
      });
      this.timSend(msg, nowTime);
      this.messageContent = "";
      this.sendPicture = "";

      console.log(msg, this.userMessageList, "msg");
      this.toBottom();
    },
    timSend(msg, nowTime) {
      let msgJson = JSON.stringify(msg);
      let message = tim.createCustomMessage({
        to: "admin",
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          data: msgJson,
        },
      });
      console.log("message=======================", message);
      let msgLength = this.userMessageList.length;
      let promise = tim.sendMessage(message);
      promise
        .then((imResponse) => {
          // 发送成功
          console.log("发送成功", imResponse);
          this.sendPicture = "";
          this.userMessageList[msgLength - 1].seq = message.sequence; //临时直接修改vuex
        })
        .catch((imError) => {
          // 发送失败
          this.errorMessageIds.push(nowTime);
          this.errorMsg = imError.message;
          if (imError.code === 10007) {
            this.errorMsg = "您已不在群聊，不能发言";
            this.$message.error("您已不在群聊，不能发言");
            return;
          }
          this.$message.error(imError.message);
          console.log("sendMessage error:", imError);
        });
    },
    onscroll() {
      // 是否滚动到了底部
      let chatBox = this.$refs.privateChat;
      let clientHeight = chatBox?.clientHeight;
      let scrollTop = chatBox?.scrollTop;
      let scrollHeight = chatBox?.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.showMoreMsg = false;
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
      if (scrollTop === 0) {
        this.page++;
        console.log("toTop", this.page);
        if (!this.noMoreMsg) {
          this.getUserHistory({ uid: this.userChatId, page: this.page });
        }
      }
    },
    toBottom() {
      this.$nextTick(() => {
        if (this.$refs["privateChat"]) {
          this.$refs["privateChat"].scrollTop = this.$refs["privateChat"].scrollHeight;
        }
      });
    },
    showErrorMsg() {
      this.$message.error(this.errorMsg);
    },
  },
};
</script>

<style scoped lang="scss">
.private-chat {
  // flex: 1;
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  position: relative;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
  margin-top: 0.12rem;
  margin-right: 0.4rem;
  .private-header {
    height: 0.42rem;
    display: flex;
    align-items: center;
    background: linear-gradient(0deg, rgba(2, 168, 162, 0.15), rgba(2, 168, 162, 0.15)), #ffffff;
    .a {
      display: flex;
      width: 0.8rem;
      color: #666666;
      font-size: 0.12rem;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
        margin-left: 0.12rem;
        margin-right: 0.05rem;
      }
    }
    .c {
      flex: 1;
      text-align: center;
      color: #000000;
    }
    .d {
      width: 0.8rem;
      display: flex;
      justify-content: flex-end;
      padding-right: 0.12rem;
      cursor: pointer;
      img {
        width: 0.24rem;
        margin-right: 0.12rem;
        cursor: pointer;
      }
    }
  }
  .private-content {
    flex: 1;
    border-bottom: 1px solid #eee;
    overflow-y: auto;
    position: relative;
    // padding: 0 0.12rem;
    background: #fff;
    /*火狐下隐藏滚动条*/
    scrollbar-width: none;
    padding: 0.08rem 0.12rem;
    color: #333333;
    .chat-time {
      text-align: center;
      margin-bottom: 0.12rem;
      color: #999;
      font-size: 0.12rem;
    }
    .chat-anchor {
      display: flex;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;
      position: relative;
      .avatar {
        position: relative;
        img {
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 0.28rem;
          margin-right: 0.08rem;
          cursor: pointer;
        }
        .popup-banned {
          z-index: 1;
          width: 1rem;
          height: 0.9rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          position: absolute;
          left: 0;
          top: -1.06rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
          .bar {
            width: 0.8rem;
            height: 0.5px;
            background: #f4f4f4;
          }
          .kickout {
            cursor: pointer;
          }
          .banned {
            cursor: pointer;
          }
        }
      }
      .msg {
        max-width: 2.34rem;
        padding: 0.05rem 0.12rem;
        background: #f4f4f4;
        border-radius: 0.1rem 0.1rem 0.1rem 0px;
        position: relative;
        cursor: pointer;
        .popup {
          width: 0.48rem;
          height: 0.44rem;
          line-height: 0.44rem;
          text-align: center;
          position: absolute;
          left: 0;
          top: -0.53rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
        }

        .nickname {
          color: #8393bc;
          display: flex;
          align-items: center;
          .role {
            width: 0.39rem;
            height: 0.2rem;
            line-height: 0.17rem;
            text-align: center;
            background: rgba(2, 161, 249, 0.2);
            border: 1px solid rgba(60, 156, 254, 0.5);
            border-radius: 0.02rem;
            color: #02a1f9;
            font-size: 0.12rem;
            transform: scale(0.83);
          }
          .role1 {
            background: rgba(2, 168, 162, 0.2);
            border: 1px solid rgba(2, 168, 162, 0.5);
            color: #02a8a2;
          }
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          left: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-word;
          white-space: pre-wrap;
          cursor: pointer;
        }
      }
    }
    .chat-user {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;

      .msg {
        max-width: 2.34rem;
        padding: 0.05rem 0.12rem;
        background: rgba(2, 168, 162, 0.2);
        border-radius: 0.1rem 0.1rem 0px 0.1rem;
        position: relative;
        cursor: pointer;
        .withdraw {
          width: 0.48rem;
          height: 0.44rem;
          line-height: 0.44rem;
          text-align: center;
          position: absolute;
          right: 0;
          top: -0.53rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
        }
        .red-dot {
          position: absolute;
          top: 0.08rem;
          left: -0.2rem;
          background: #db6372;
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 0.16rem;
          line-height: 0.16rem;
          text-align: center;
          color: #ffffff;
          margin-right: 0.04rem;
          cursor: pointer;
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          right: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-word;
          white-space: pre-wrap;
        }
      }
      .avatar {
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 0.28rem;
        margin-left: 0.08rem;
      }
    }
  }
  .to_bottom_btn {
    width: 3.4rem;
    height: 0.3rem;
    background: rgba(2, 168, 162, 0.7);
    text-align: center;
    line-height: 0.3rem;
    color: #fff;
    font-size: 0.12rem;
    // position: absolute;
    // top: -0.3rem;
    // left: 50%;
    // transform: translateX(-50%);
    position: relative;
    cursor: pointer;

    &::before {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      // top: 60%;
      bottom: 0;
      left: 32%;
      transform: translateY(-50%);
      border: 0.05rem solid transparent;
      border-top: 0.05rem solid #fff;
    }
  }
  .message_bottom {
    position: relative;
    // height: 1.08rem;
    height: 1rem;
    padding: 0 0.16rem;
    background: #ffffff;
    .icon_btn {
      display: flex;
      align-items: center;
      height: 0.4rem;
      .icon-img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.1rem;
        cursor: pointer;
      }
    }
    .emoji {
      width: 3.39rem;
      position: absolute;
      top: -1.6rem;
      left: 0;
      background-color: #fff;
      border-top: 0.01rem solid #eee;
    }
    .emoji-cats {
      display: flex;
      .emoji-cat {
        width: 0.85rem;
        height: 0.3rem;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .emoji-active {
        background-color: #fff;
      }
    }
    .emoji-item {
      height: 1.3rem;
      padding: 0.1rem;
      overflow: scroll;
      span {
        margin: 0.03rem;
        margin-bottom: 0.05rem;
        display: inline-block;
        cursor: pointer;
      }
    }

    .sent_content {
      width: 100%;
      display: flex;

      .input_content {
        flex: 1;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 4px 0 0 4px;
        height: 0.48rem;
        font-size: 0.12rem;
        display: flex;
        justify-content: space-between;

        .login_input {
          width: 100%;
          padding: 0.12rem 0.16rem;
          border: none;
          outline: none;
          height: 100%;
        }
      }
      .input_send {
        background: #02a8a2;
        border-radius: 0px 4px 4px 0px;
        color: #fff;
        width: 0.6rem;
        height: 0.48rem;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.48rem;
        cursor: pointer;
      }
    }
  }
}
</style>
